import { useLayoutEffect, useRef } from "react";

export const useMaskedPasswordCaret = () => {
  const inputRef = useRef(null);
  const caretRef = useRef(null);

  useLayoutEffect(() => {
    if (
      caretRef.current !== null &&
      inputRef.current
    ) {
      inputRef.current.setSelectionRange(
        caretRef.current,
        caretRef.current
      );
      caretRef.current = null;
    }
  });

  const handleKeyDown = (e, value, onChange, isVisible) => {
    if (isVisible) return;

    const input = e.target;
    const start = input.selectionStart;
    const end = input.selectionEnd;

    const commit = (newValue, nextCaret) => {
      caretRef.current = nextCaret;
      onChange(newValue);
    };

    // Allow Ctrl+A
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "a") {
      return;
    }

    if (
      e.key.length === 1 ||
      e.key === "Backspace" ||
      e.key === "Delete"
    ) {
      e.preventDefault();

      // CASE 1: selection
      if (start !== end) {
        commit(
          value.slice(0, start) + value.slice(end),
          start
        );
        return;
      }

      // CASE 2: Backspace
      if (e.key === "Backspace") {
        if (start > 0) {
          commit(
            value.slice(0, start - 1) + value.slice(start),
            start - 1
          );
        }
        return;
      }

      // CASE 3: Delete
      if (e.key === "Delete") {
        if (start < value.length) {
          commit(
            value.slice(0, start) + value.slice(start + 1),
            start
          );
        }
        return;
      }

      // CASE 4: Insert char
      if (
        e.key.length === 1 &&
        !e.ctrlKey &&
        !e.metaKey &&
        !e.altKey
      ) {
        commit(
          value.slice(0, start) + e.key + value.slice(end),
          start + 1
        );
      }
    }
  };

  return { inputRef, handleKeyDown };
};
